import { database } from "../firebase";

export const fetchInvitationDetails = async (details) => {
  try {
    const invitation = await database
      .collection("invitations")
      .doc(details.id)
      .get();

    if (invitation.exists) {
      if (invitation.data().used === false) {
        return {
          error: null,
          payload: {
            email: invitation.data().recipient,
            organizationNumber: invitation.data().organizationNumber,
          },
        };
      } else {
        throw new Error("Invitasjonen er allerede blitt brukt.");
      }
    } else {
      throw new Error("Invitasjonen eksisterer ikke.");
    }
  } catch (e) {
    throw new Error(e);
  }
};
